module.exports = __webpack_public_path__ + "img/bg-home.c391df03.jpg";